// https://github.com/ArmageddonGames/ZeldaClassic/blob/2.55-master/src/dialog/quest_rules.cpp#L30

function bit(flag: number, index: number) {
  return (flag & (1 << index)) !== 0;
}

function read(flagIndex: number, bitIndex: number) {
  return (flags: number[]) => bit(flags[flagIndex], bitIndex);
}

const names = [
  'SOLIDBLK',
  'NOTMPNORET',
  'ALWAYSRET',
  'MEANTRAPS',
  'BSZELDA',
  'FADE',
  'FADECS5',
  'FASTDNGN',
  'NOLEVEL3FIX',
  'COOLSCROLL',
  'NOSCROLL',
  '4TRI',
  'EXPLICIT_RAFTING',
  'FASTFILL',
  'CAVEEXITNOSTOPMUSIC',
  '3TRI',
  'TIME',
  'FREEFORM',
  'KILLALL',
  'NOFLICKER',
  'CONTFULL_DEP',
  'RLFIX',
  'LENSHINTS',
  'HERODUNGEONPOSFIX',
  'HOLDITEMANIMATION',
  'HESITANTPUSHBLOCKS',
  'HIDECARRIEDITEMS',
  'FFCSCROLL',
  'RAFTLENS',
  'SMOOTHVERTICALSCROLLING',
  'WHIRLWINDMIRROR',
  'NOFLASHDEATH',
  'HOLDNOSTOPMUSIC',
  'FIREPROOFHERO',
  'OUCHBOMBS',
  'NOCLOCKS_DEP',
  'TEMPCLOCKS_DEP',
  'BRKBLSHLDS_DEP',
  'BRKNSHLDTILES',
  'MEANPLACEDTRAPS',
  'PHANTOMPLACEDTRAPS',
  'ALLOWFASTMSG',
  'LINKEDCOMBOS',
  'NOGUYFIRES',
  'HEARTRINGFIX',
  'NOHEARTRING',
  'OVERWORLDTUNIC',
  'SWORDWANDFLIPFIX',
  'ENABLEMAGIC',
  'MAGICWAND_DEP',
  'MAGICCANDLE_DEP',
  'MAGICBOOTS_DEP',
  'NONBUBBLEMEDICINE',
  'NONBUBBLEFAIRIES',
  'NONBUBBLETRIFORCE',
  'NEWENEMYTILES',
  'NOROPE2FLASH_DEP',
  'NOBUBBLEFLASH_DEP',
  'GHINI2BLINK_DEP',
  'BITMAPOFFSETFIX',
  'PHANTOMGHINI2_DEP',
  'Z3BRANG_HSHOT',
  'NOITEMMELEE',
  'SHADOWS',
  'TRANSSHADOWS',
  'QUICKSWORD',
  'BOMBHOLDFIX',
  'EXPANDEDLTM',
  'NOPOTIONCOMBINE_DEP',
  'HEROFLICKER',
  'SHADOWSFLICKER',
  'WALLFLIERS',
  'NOBOMBPALFLASH',
  'HEARTSREQUIREDFIX',
  'PUSHBLOCKCSETFIX',
  'TRANSLUCENTNAYRUSLOVEROCKET_DEP',
  'FLICKERINGNAYRUSLOVEROCKET_DEP',
  'CMBCYCLELAYERS',
  'DMGCOMBOPRI',
  'WARPSIGNOREARRIVALPOINT',
  'LTTPCOLLISION',
  'LTTPWALK',
  'SLOWENEMYANIM_DEP',
  'TRUEARROWS',
  'NOSAVE',
  'NOCONTINUE',
  'QUARTERHEART',
  'NOARRIVALPOINT',
  'NOGUYPOOF',
  'ALLOWMSGBYPASS',
  'NODIVING',
  'LAYER12UNDERCAVE',
  'NOSCROLLCONTINUE',
  'SMARTSCREENSCROLL',
  'RINGAFFECTDAMAGE',
  'ALLOW10RUPEEDROPS_DEP',
  'TRAPPOSFIX',
  'TEMPCANDLELIGHT',
  'REDPOTIONONCE_DEP',
  'OLDSTYLEWARP',
  'NOBORDER',
  'OLDTRIBBLES_DEP',
  'REFLECTROCKS',
  'OLDPICKUP',
  'ENEMIESZAXIS',
  'SAFEENEMYFADE',
  'MORESOUNDS',
  'BRANGPICKUP',
  'HEARTPIECEINCR_DEP',
  'ITEMSONEDGES',
  'EATSMALLSHIELD_DEP',
  'MSGFREEZE',
  'SLASHFLIPFIX',
  'FIREMAGICSPRITE_DEP',
  'SLOWCHARGINGWALK',
  'NOWANDMELEE',
  'SLOWBOMBFUSES_DEP',
  'SWORDMIRROR',
  'SELECTAWPN',
  'LENSSEESENEMIES',
  'INSTABURNFLAGS',
  'DROWN',
  'MSGDISAPPEAR',
  'SUBSCREENOVERSPRITES',
  'BOMBDARKNUTFIX',
  'LONGBOMBBOOM_DEP',
  'OFFSETEWPNCOLLISIONFIX',
  'DMGCOMBOLAYERFIX',
  'ITEMSINPASSAGEWAYS',
  'LOG',
  'FIREPROOFHERO2',
  'NOITEMOFFSET',
  'ITEMBUBBLE',
  'GOTOLESSNOTEQUAL',
  'LADDERANYWHERE',
  'HOOKSHOTLAYERFIX',
  'REPLACEOPENDOORS',
  'OLDLENSORDER',
  'NOFAIRYGUYFIRES',
  'SCRIPTERRLOG',
  'TRIGGERSREPEAT',
  'ENEMIESFLICKER',
  'OVALWIPE',
  'TRIANGLEWIPE',
  'SMASWIPE',
  'NOSOLIDDAMAGECOMBOS',
  'SHOPCHEAT',
  'HOOKSHOTDOWNBUG',
  'OLDHOOKSHOTGRAB',
  'PEAHATCLOCKVULN',
  'VERYFASTSCROLLING',
  'OFFSCREENWEAPONS',
  'BROKENSTATUES',
  'BOMBCHUSUPERBOMB',
  'ITEMPICKUPSETSBELOW',
  'GANONINTRO',
  'MELEEMAGICCOST',
  'OLDMIRRORCOMBOS',
  'BROKENBOOKCOST',
  'OLDSIDEVIEWSPIKES',
  'OLDINFMAGIC',
  'NEVERDISABLEAMMOONSUBSCREEN',
  'ITEMSCRIPTSKEEPRUNNING',
  'SCRIPTSRUNINHEROSTEPFORWARD',
  'SCRIPTDRAWSINCANCELWARP',
  'FIXSCRIPTSDURINGSCROLLING',
  'SCRIPTDRAWSINWARPS',
  'DYINGENEMYESDONTHURTHERO',
  'SIDEVIEWTRIFORCECELLAR',
  'OUTOFBOUNDSENEMIES',
  'EPILEPSY',
  'SCRIPT_FRIENDLY_ENEMY_TYPES',
  'SMARTDROPS',
  'NO_L_R_BUTTON_INVENTORY_SWAP',
  'USE_EX1_EX2_INVENTORYSWAP',
  'NOFASTMODE',
  'OLD_F6',
  'BROKEN_ASKIP_Y_FRAMES',
  'ENEMY_BROKEN_TOP_HALF_SOLIDITY',
  'SIDEVIEWLADDER_FACEUP',
  'ITEMS_IGNORE_SIDEVIEW_PLATFORMS',
  'DOWN_FALL_THROUGH_SIDEVIEW_PLATFORMS',
  'SIDEVIEW_FALLTHROUGH_USES_DRUNK',
  'DOWN_DOESNT_GRAB_LADDERS',
  'DOWNJUMP_FALL_THROUGH_SIDEVIEW_PLATFORMS',
  'OLD_SIDEVIEW_CEILING_COLLISON',
  '0AFRAME_ITEMS_IGNORE_AFRAME_CHANGES',
  'OLD_ENEMY_KNOCKBACK_COLLISION',
  'FADEBLACKWIPE',
  'PASSIVE_SUBSCRIPT_RUNS_DURING_ACTIVE_SUBSCRIPT',
  'DMAP_ACTIVE_RUNS_DURING_ACTIVE_SUBSCRIPT',
  'ANIMATECUSTOMWEAPONS',
  'WEAPONSMOVEOFFSCREEN',
  'CHECKSCRIPTWEAPONOFFSCREENCLIP',
  'SHORTDGNWALK',
  'SCRIPT_WEAPONS_UNIQUE_SPRITES',
  'ANGULAR_REFLECTED_WEAPONS',
  'MIRRORS_USE_WEAPON_CENTER',
  'CUSTOMCOMBOSLAYERS1AND2',
  'BUSHESONLAYERS1AND2',
  'NEW_HERO_MOVEMENT',
  'DISABLE_4WAY_GRIDLOCK',
  'NEW_COMBO_ANIMATION',
  'OLD_STRING_EDITOR_MARGINS',
  'NO_OVERWRITING_HOPPING',
  'DUNGEON_DMAPS_PERM_SECRETS',
  'STRING_FRAME_OLD_WIDTH_HEIGHT',
  'NO_SCROLL_WHILE_IN_AIR',
  'INSTANT_RESPAWN',
  'BROKEN_OVERWORLD_MINIMAP',
  'NO_STUNLOCK',
  'GREATER_MAX_TIME',
  'BROKEN_RING_POWER',
  'NO_OVERWORLD_MAP_CHARTING',
  'DUNGEONS_USE_CLASSIC_CHARTING',
  'ARROWS_ALWAYS_PENETRATE',
  'SWORDBEAMS_ALWAYS_PENETRATE',
  'SET_XBUTTON_ITEMS',
  'SMARTER_WATER',
  'NO_HOPPING',
  'NO_SOLID_SWIM',
  'WATER_ON_LAYER_1',
  'WATER_ON_LAYER_2',
  'SHALLOW_SENSITIVE',
  'SMARTER_SMART_SCROLL',
  'INSTANT_CONTINUE',
  'NONHEAVY_BLOCKTRIGGER_PERM',
  'SET_YBUTTON_ITEMS',
  'CORRECTED_EW_BRANG_ANIM',
  'SCRIPT_WRITING_HEROSTEP_DOESNT_CARRY_OVER',
  'OVERHEAD_COMBOS_L1_L2',
  'ALLOW_EDITING_COMBO_0',
  'OLD_CHEST_COLLISION',
  'AUTOCOMBO_LAYER_1',
  'AUTOCOMBO_LAYER_2',
  'TRUEFIXEDBOMBSHIELD',
  'BOMBSPIERCESHIELD',
  'BROKEN_HORIZONTAL_WEAPON_ANIM',
  'NEW_DARKROOM',
  'NEWDARK_L6',
  'ENEMIES_SECRET_ONLY_16_31',
  'SCREEN80_OWN_MUSIC',
  'OLDCS2',
  'HARDCODED_ENEMY_ANIMS',
  'OLD_ITEMDATA_SCRIPT_TIMING',
  'SIDESWIM',
  'SIDESWIMDIR',
  'PUSHBLOCK_LAYER_1_2',
  'NEWDARK_SCROLLEDGE',
  'STEPTEMP_SECRET_ONLY_16_31',
  'ALLTRIG_PERMSEC_NO_TEMP',
  'HARDCODED_LITEM_LTMS',
  'NO_BOTTLE_IF_ANY_COUNTER_FULL',
  'LIGHTBEAM_TRANSPARENT',
  'CANDLES_SHARED_LIMIT',
  'OLD_RESPAWN_POINTS',
  'HOOKSHOTALLLAYER',
  'ANONE_NOANIM',
  'BLOCKHOLE_SAME_ONLY',
  'SWITCHOBJ_RUN_SCRIPT',
  'ITEMCOMBINE_NEW_PSTR',
  'ITEMCOMBINE_CONTINUOUS',
  'SCC_ITEM_COMBINES_ITEMS',
  'SCROLLING_KILLS_CHARGE',
  'CUSTOMWEAPON_IGNORE_COST',
  'BLOCKS_DONT_LOCK_OTHER_LAYERS',
  'FIXED_FAIRY_LIMIT',
  'FAIRYDIR',
  'ARROWCLIP',
  'CONT_SWORD_TRIGGERS',
  'OLD_210_WATER',
  '8WAY_SHOT_SFX',
  'COPIED_SWIM_SPRITES',
  'WRONG_BRANG_TRAIL_DIR',
  '192b163_WARP',
  '210_WARPRETURN',
  'LESS_AWFUL_SIDESPIKES',
  'OLD_LADDER_ITEM_SIDEVIEW',
  'OLD_SECRETMONEY',
  'OLD_DOORREPAIR',
  'OLD_POTION_OR_HC',
  'NO_LANMOLA_RINGLEADER',
  'HARDCODED_BS_PATRA',
  'PATRAS_USE_HARDCODED_OFFSETS',
  'BROKEN_BIG_ENEMY_ANIMATION',
  'BROKEN_ATTRIBUTE_31_32',
  'CAN_PLACE_GANON',
  'CAN_PLACE_TRAPS',
  'FIND_CLOSEST_BAIT',
  'OLD_FLAMETRAIL_DURATION',
  'PERMANENT_WHISTLE_SECRETS',
  'SMARTER_DROPS',
  'WAVY_NO_EPILEPSY',
  'WAVY_NO_EPILEPSY_2',
  'DYING_ENEMIES_IGNORE_STUN',
  'SHOP_ITEMS_VANISH',
  'ANGULAR_REFLECT_BROKEN',
  'CSET1_LEVEL',
  'CSET5_LEVEL',
  'CSET7_LEVEL',
  'CSET8_LEVEL',
  'FADECS1',
  'FADECS7',
  'FADECS8',
  'FADECS9',
  'UNBEATABLES_DONT_KEEP_DEAD',
  'NO_LEAVE_ONE_ENEMY_ALIVE_TRICK',
  'OLD_BRIDGE_COMBOS',
  'BROKEN_Z3_ANIMATION',
  'OLD_TILE_INITIALIZATION',
  'FLUCTUATING_ENEMY_JUMP',
  'SPRITE_JUMP_IS_TRUNCATED',
  'BUGGY_BUGGY_SLASH_TRIGGERS',
  'OLD_DRAWOFFSET',
  'BROKEN_DRAWSCREEN_FUNCTIONS',
  'ENEMY_DROPS_USE_HITOFFSETS',
  'BROKEN_ITEM_CARRYING',
  'LEEVERS_DONT_OBEY_STUN',
  'QUAKE_STUNS_LEEVERS',
  'GANON_CANT_SPAWN_ON_CONTINUE',
  'WIZZROBES_DONT_OBEY_STUN',
  'OLD_BUG_NET',
  'MANHANDLA_BLOCK_SFX',
  'GRASS_SENSITIVE'
] as const;

export const QuestRules = {} as Record<typeof names[number], ReturnType<typeof read>>;
for (let i = 0; i < names.length; i++) {
  const name = names[i];
  QuestRules[name] = read(Math.floor(i / 8), i % 8);
}
